import styled from 'styled-components';

export const Container = styled.div`
  margin: 1rem;
  position: relative;
  max-width: 100%;

  h6 {
    color: ${({ theme }) => theme.colors.textPrimary};
    background: ${({ theme }) => theme.colors.bg};
    padding: 0.25rem 0.75rem;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
`;

export const Thumb = styled.div`
  height: 12.5rem;
  background: ${({ theme }) => theme.colors.primary};
  position: relative;
  width: 100%;

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

export const ContainerButtons = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  align-items: center;

  button {
    background: ${({ theme }) => theme.colors.tertiary};
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 1.1rem;
    border-radius: 8px;
    padding: 0.25rem;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;

    & + button {
      margin-left: 0.5rem;
    }
  }
`;
